import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export type ChartLegendProps = {
  color: string;
  icon: IconProp;
  text: string;
  strokeDashArray?: string;
};

export const ChartLegend = ({
  color,
  icon,
  text,
  strokeDashArray,
}: ChartLegendProps) => {
  return (
    <div
      className="flex items-center text-base"
      style={{
        display: "grid",
        gridTemplateColumns: "2rem max-content 1fr",
        color: color,
      }}
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke={color}
          strokeDasharray={strokeDashArray}
          d="M0 16 L32 16"
          strokeWidth="4"
        ></path>
      </svg>
      <div className="fcen mx-2">{icon && <FontAwesomeIcon icon={icon} />}</div>
      {text && <div className="text-high">{text}</div>}
    </div>
  );
};
